import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function noTrimmedEmpty(minLength: number = 1): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const rawValue = control.value;

        if (rawValue == null || rawValue === '') {
            return null;
        }

        const value = rawValue.trim();

        if (value.length < minLength) {
            return {
                minlength: {
                    requiredLength: minLength,
                    actualLength: value.length,
                },
            };
        }

        return null;
    };
}
